// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"e4957927","915":"b25d9ae4"}[chunkId] + ".chunk.css";
};